import React from 'react';

const FullBleedImage = ({ src, alt, className = '', objectPosition, objectFit = 'cover', srcSet, sizes }) => {
  // The `className` prop is applied to the root div of this component.
  // This root div should be given explicit height by its parent or via its own classes.
  return (
    <div className={`w-full overflow-hidden max-h-[500px] ${className}`}> {/* Ensure this div gets the intended height */}
      <img
        src={src}
        alt={alt}
        className="w-full h-full"
        style={{ objectFit, objectPosition: objectPosition || 'center' }} // Default to center if not specified
        loading="lazy"
        {...(srcSet ? { srcSet } : {})}
        {...(sizes ? { sizes } : {})}
      />
    </div>
  );
};

export default FullBleedImage; 